import {
  SET_LOADING,
  SET_RECRUITER,
  SET_RECRUITER_AUDITION,
  SET_RECRUITER_LIST,
  SET_RECRUITER_LIST_META,
  SET_RECRUITER_IMAGES,
  SET_RECRUITER_PROFILE_LIST,
  SET_RECRUITER_PROFILE_LIST_META,
  SET_RECRUITER_PROFILE,
  APPEND_RECRUITER_PROFILE_LIST,
  SET_SELECTED_RECRUITER,
} from "../../actions/recruiter/types";

const INITIAL_STATE = {
  loading: false,
  recruiterList: [],
  recruiterListMetaData: null,
  selectedRecruiter: null,
  recruiterProfileList: [],
  recruiterProfileListMetaData: {
    loading: false,
    hasMore: true,
  },
  selectedRecruiterProfile: null,
  selectedRecruiterAuditions: [],
  selectedRecruiterImages: [],
  selectedRecruiter: null,
};

const RecruiterReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_RECRUITER_LIST: {
      return {
        ...state,
        recruiterList: action.payload,
      };
    }
    case SET_RECRUITER_LIST_META: {
      return {
        ...state,
        recruiterListMetaData: action.payload,
      };
    }
    case SET_RECRUITER: {
      return {
        ...state,
        selectedRecruiter: action.payload,
      };
    }
    case SET_RECRUITER_PROFILE_LIST: {
      return {
        ...state,
        recruiterProfileList: action.payload,
      };
    }
    case SET_RECRUITER_PROFILE_LIST_META: {
      return {
        ...state,
        recruiterProfileListMetaData: action.payload,
      };
    }
    case APPEND_RECRUITER_PROFILE_LIST: {
      return {
        ...state,
        recruiterProfileList: [
          ...state.recruiterProfileList,
          ...action.payload,
        ],
      };
    }
    case SET_RECRUITER_PROFILE: {
      return {
        ...state,
        selectedRecruiterProfile: action.payload,
      };
    }
    case SET_SELECTED_RECRUITER: {
      return {
        ...state,
        selectedRecruiter: action.payload,
      };
    }
    case SET_RECRUITER_AUDITION: {
      return {
        ...state,
        selectedRecruiterAuditions: action.payload,
      };
    }
    case SET_RECRUITER_IMAGES: {
      return {
        ...state,
        selectedRecruiterImages: action.payload,
      };
    }
    case SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default RecruiterReducer;
